export const MAX_LENGTH_FORM_EMAIL = 64
export const MIN_LENGTH_FORM_NAME = 2
export const MAX_LENGTH_FORM_NAME = 64
export const MIN_LENGTH_FORM_BODY = 10
export const MAX_LENGTH_FORM_BODY = 2000
export const RECAPTCHA_V2_PROPERTY_NAME = 'g-recaptcha-v2-response'
export const RECAPTCHA_V3_PROPERTY_NAME = 'g-recaptcha-response'
